import React__default from 'react';
import PT from 'prop-types';
import { P as PaginationDropdown } from './PaginationDropdown/PaginationDropdown-BD8ctLcK.js';
import { P as PaginationPageStatus } from './PaginationPageStatus/PaginationPageStatus-Bct8r8Mp.js';
import { P as PaginationFirstButton } from './PaginationButton/PaginationFirstButton-CP3aAaT_.js';
import { P as PaginationLastButton } from './PaginationButton/PaginationLastButton-DO3sJcn_.js';
import { P as PaginationNextButton } from './PaginationButton/PaginationNextButton-uNv-M-3h.js';
import { P as PaginationPrevButton } from './PaginationButton/PaginationPrevButton-MM_eSNXp.js';
import { P as PaginationNavGroup } from './Pagination.styles-BO1n7VVn.js';
import { B as BasePagination } from './BasePagination-MnIP76ZX.js';

const Pagination = props => {
  const {
    id,
    currentPageLabel,
    firstPageLabel,
    lastPageLabel,
    nextPageLabel,
    prevPageLabel,
    pageSizes,
    currentPage,
    currentSize,
    totalPages,
    onSetPageSize,
    setCurrentPage,
    renderPaginationDropdownLabel,
    taktId,
    taktValue
  } = props;
  return /*#__PURE__*/React__default.createElement(BasePagination, {
    taktId: taktId,
    taktValue: taktValue,
    id: id
  }, /*#__PURE__*/React__default.createElement(PaginationDropdown, {
    id: `${id}-dropdown`,
    currentSize: currentSize,
    pageSizes: pageSizes,
    onSetPageSize: onSetPageSize,
    renderPaginationDropdownLabel: renderPaginationDropdownLabel
  }), /*#__PURE__*/React__default.createElement(PaginationPageStatus, {
    id: `${id}-page-status`,
    currentPageLabel: currentPageLabel,
    "aria-live": "polite"
  }), /*#__PURE__*/React__default.createElement(PaginationNavGroup, {
    "aria-controls": `${id}-page-status`,
    "aria-labelledby": `${id}-page-status`
  }, /*#__PURE__*/React__default.createElement(PaginationFirstButton, {
    id: `${id}-first`,
    ariaLabel: firstPageLabel,
    onClick: () => setCurrentPage(0),
    disabled: currentPage === 0 || totalPages === 0,
    taktFallbackId: "first-button"
  }), /*#__PURE__*/React__default.createElement(PaginationPrevButton, {
    id: `${id}-prev`,
    ariaLabel: prevPageLabel,
    onClick: () => setCurrentPage(currentPage - 1),
    disabled: currentPage === 0 || totalPages === 0,
    taktFallbackId: "prev-button"
  }), /*#__PURE__*/React__default.createElement(PaginationNextButton, {
    id: `${id}-next`,
    ariaLabel: nextPageLabel,
    onClick: () => setCurrentPage(currentPage + 1),
    disabled: currentPage === totalPages - 1 || totalPages === 0,
    taktFallbackId: "next-button"
  }), /*#__PURE__*/React__default.createElement(PaginationLastButton, {
    id: `${id}-last`,
    ariaLabel: lastPageLabel,
    onClick: () => setCurrentPage(totalPages - 1),
    disabled: currentPage === totalPages - 1 || totalPages === 0,
    taktFallbackId: "last-button"
  })));
};
Pagination.propTypes = {
  /**
    * Each interactive element will have an id based off of this.
    */
  id: PT.string.isRequired,
  /**
    * The text that displays "x out of 12 pages" in the example.
    */
  currentPageLabel: PT.string.isRequired,
  /**
    * Labels are required for screen reader accessibility.
    */
  firstPageLabel: PT.string.isRequired,
  /**
    * Labels are required for screen reader accessibility.
    */
  lastPageLabel: PT.string.isRequired,
  /**
    * Labels are required for screen reader accessibility.
    */
  nextPageLabel: PT.string.isRequired,
  /**
    * Labels are required for screen reader accessibility.
    */
  prevPageLabel: PT.string.isRequired,
  /**
    * The page sizes that the user can select from.
    */
  pageSizes: PT.arrayOf(PT.number.isRequired).isRequired,
  /**
    * The page the user is currently on (0-indexed).
    */
  currentPage: PT.number.isRequired,
  /**
    * The current page size.
    */
  currentSize: PT.number.isRequired,
  /**
    * The total number of pages for nav disabling purposes.
    */
  totalPages: PT.number.isRequired,
  /**
    * onChange handler for changing the page size.
    */
  onSetPageSize: PT.func.isRequired,
  /**
    * Setter for page navigation changes.
    */
  setCurrentPage: PT.func.isRequired,
  /**
    * The text that displays on the dropdown.
    */
  renderPaginationDropdownLabel: PT.func
};
Pagination.defaultProps = {
  renderPaginationDropdownLabel: pageSize => `${pageSize}`
};

export { Pagination as P };
//# sourceMappingURL=Pagination-ylox0Rhb.js.map
